import { Field, Input } from '@fluentui/react-components';
import React, { memo, useCallback, useMemo } from 'react';
import { editWorkItemStyles } from '../styles';
import { useAutomationRuleActions } from '../../use-actions';
import { ActionItemType, EditWorkItemActionType } from '../../types';

interface Props {
  id?: string;
  actionId: string;
  validationError: string | null;
  type?: 'number'| 'text';
}

function TextInputComponent(props: Props) {
	const classes = editWorkItemStyles();
	const {actions, setActions, resetValidationErrors} = useAutomationRuleActions();

	const current: EditWorkItemActionType = useMemo(() => {
		const foundActions = actions.find(item => item.id === props.actionId) as ActionItemType;
		return foundActions!.editWorkItem as EditWorkItemActionType;
	}, [actions, props.actionId]);

	const onChangeText = useCallback((value: string) => {
		resetValidationErrors();
		setActions((oldValues) => {
			return oldValues.map((item) => {
				if (item.id === props.actionId) {
					const editWorkItemValues = item!.editWorkItem as EditWorkItemActionType;
					return {
						...item,
						editWorkItem: {
							...editWorkItemValues,
							textValue: value,
						}
					};
				}

				return {
					...item,
				};
			});
		});
	}, [props.actionId]);

	return (
		<Field
			className={classes.dropdownRoot}
			validationMessage={props.validationError}
		>
			<Input
				type={props.type}
				autoComplete='off'
				appearance='outline'
				className={classes.input}
				placeholder='Enter a value'
				value={current.textValue}
				onChange={(_, data) => {
					onChangeText(data.value);
				}}
			/>
		</Field>
	);
}

const TextInput = memo(TextInputComponent);
export default TextInput;